import axios from 'axios';
import { DEFAULT_PREVIEW_CONTENT } from './layout-service';

export const getPreviewEncode = async (accountId, params) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/preview-encode`;
  return axios.post(url, params).then((response) => {
    return response.data;
  });
};

export const getAllPreviewInventoryData = async (accountId) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/preview-inventory`;
  return axios.get(url).then((response) => {
    return response.data;
  });
};

export const getPreviewInventoryData = async (accountId, previewInventoryId) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/preview-inventory/${previewInventoryId}`;
  return axios.get(url).then((response) => {
    if (!response.data) return DEFAULT_PREVIEW_CONTENT;
    return response.data;
  });
};
